import { cloneDeep, merge } from 'lodash';
import deepFreeze from './deep-freeze';
export default (base, modifier) => {
    const baseClone = cloneDeep(base);
    const merged = merge(baseClone, modifier)
    return deepFreeze(merged);
}